import { useState } from "react";
import { Button, Grid, InputLabel, Paper, TextField, Typography } from "@mui/material";
import { updateProfile } from "../../../actions/profile";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import PropTypes from "prop-types";

import { useDispatch } from "react-redux";

const MainSobreTi = ({ data, onChange }) => {
  const dispatch = useDispatch();

  const [isEditing, setIsEditing] = useState(false);

  const toggleEdit = () => {
    const newState = !isEditing;
    setIsEditing(newState);
  }

  const guardarPerfil = async () => {
    const info = {
      rol: data.rol,
      desc: data.desc,
      website: data.website
    };
    await dispatch(updateProfile(info));
    setIsEditing(false)
  }

  return (
    <Grid container spacing={1} mb={2} mt={2} size={12}>
      {/* Header Section */}
      <Grid size={12} container justifyContent="space-between" alignItems="center" mb={3}>
        <Grid>
          <Typography variant="h3" color="primary">
            Sobre ti
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Gestiona tu perfil público agregando información sobre ti.
          </Typography>
        </Grid>
        <Grid hidden={isEditing}>
          <Button
            variant="contained"
            startIcon={<DriveFileRenameOutlineIcon />}
            color='secondary'
            onClick={toggleEdit}
          >
            Editar
          </Button>
        </Grid>
      </Grid>

      <Paper sx={{ padding: 3, width: '150vh' }}>
        <Grid container size={12} spacing={3}>
          {/* Rol Section */}
          <Grid size={{ xs: 12, md: 6 }}>
            <InputLabel htmlFor="rol" sx={{ mb: 1 }}>
              Te dedicas a:
            </InputLabel>
            {
              isEditing ? (
                <TextField
                  id="rol"
                  placeholder="Ej. Diseñadora de interiores, Maestro de yoga, Desarrollador web…"
                  size="small"
                  fullWidth
                  value={data.rol}
                  onChange={(e) => onChange("rol", e.target.value)}
                />
              ) : (
                <Typography fontWeight="bold">
                  {data.rol}
                </Typography>
              )
            }
          </Grid>

          {/* Website Section */}
          <Grid size={{ xs: 12, md: 6 }}>
            <InputLabel htmlFor="web" sx={{ mb: 1 }}>
              Página Web
            </InputLabel>
            {
              isEditing ? (
                <TextField
                  id="web"
                  placeholder="Ej.www.misservicios.com"
                  size="small"
                  fullWidth
                  value={data.website}
                  onChange={(e) => onChange("website", e.target.value)}
                />
              ) : (
                <Typography fontWeight="bold">
                  {data.website}
                </Typography>
              )
            }
          </Grid>

          <Grid size={12}>
            <Grid size={12} sx={{ borderBottom: 1, borderColor: 'grey.300', mb: 2 }} />
          </Grid>

          {/* Description Section */}
          <Grid size={12}>
            <InputLabel htmlFor="resena" sx={{ mb: 1 }}>
              La reseña que tenemos de ti es:
            </InputLabel>
            {
              isEditing ? (
                <TextField
                  id="resena"
                  size="small"
                  multiline
                  rows={4}
                  placeholder="En menos de 250 caracteres cuentanos de ti en 
                  torno a lo que te dedicas. Ej.Llevo más de 5 años ayudando a personas a 
                  transformar sus espacios con diseño funcional y emocional…"
                  fullWidth
                  value={data.desc}
                  onChange={(e) => onChange("desc", e.target.value)}
                />
              ) : (
                <Typography fontWeight="bold">
                  {data.desc}
                </Typography>
              )
            }
          </Grid>
        </Grid>

        {/* Save Button */}
        {
          isEditing && (
            <Grid size={12} container justifyContent="flex-end" mt={3} spacing={2}>
              <Button
                variant="outlined"
                size="large"
                onClick={() => setIsEditing(false)}
              >
                Cancelar
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={guardarPerfil}
              >
                Guardar
              </Button>
            </Grid>
          )
        }
      </Paper>
    </Grid>
  );
}

MainSobreTi.propTypes = {
  data: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default MainSobreTi;